var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8841 12H19.1159C17.9473 12 17 12.9203 17 14.0555V25.9445C17 27.0797 17.9473 28 19.1159 28H39.8841C41.0527 28 42 27.0797 42 25.9445V14.0555C42 12.9203 41.0527 12 39.8841 12Z",
    fill: "url(#paint0_linear_1640_38204)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7843 0H3.2157C1.43972 0 0 1.43773 0 3.21127V21.7887C0 23.5623 1.43972 25 3.2157 25H34.7843C36.5603 25 38 23.5623 38 21.7887V3.21127C38 1.43773 36.5603 0 34.7843 0Z",
    fill: "url(#paint1_linear_1640_38204)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7843 0H3.2157C1.43972 0 0 1.43773 0 3.21127V21.7887C0 23.5623 1.43972 25 3.2157 25H34.7843C36.5603 25 38 23.5623 38 21.7887V3.21127C38 1.43773 36.5603 0 34.7843 0Z",
    fill: "url(#paint2_linear_1640_38204)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38204)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.72,
    filter: "url(#filter0_f_1640_38204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8841 12H19.1159C17.9473 12 17 12.9203 17 14.0555V25.9445C17 27.0797 17.9473 28 19.1159 28H39.8841C41.0527 28 42 27.0797 42 25.9445V14.0555C42 12.9203 41.0527 12 39.8841 12Z",
    fill: "url(#paint3_linear_1640_38204)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26853 7H5.73147C4.77521 7 4 7.75605 4 8.68867V10.3113C4 11.244 4.77521 12 5.73147 12H9.26853C10.2248 12 11 11.244 11 10.3113V8.68867C11 7.75605 10.2248 7 9.26853 7Z",
    fill: "#FFA09C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4892 19H5.51076C5.22857 19 5 18.5525 5 18C5 17.4475 5.22857 17 5.51076 17H10.4892C10.7714 17 11 17.4475 11 18C11 18.5525 10.7714 19 10.4892 19Z",
    fill: "#FFA09C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4892 19H16.5108C16.2286 19 16 18.5525 16 18C16 17.4475 16.2286 17 16.5108 17H21.4892C21.7714 17 22 17.4475 22 18C22 18.5525 21.7714 19 21.4892 19Z",
    fill: "#FFA09C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4041 19H27.5959C27.2667 19 27 18.5525 27 18C27 17.4475 27.2667 17 27.5959 17H33.4041C33.7333 17 34 17.4475 34 18C34 18.5525 33.7333 19 33.4041 19Z",
    fill: "#FFA09C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1640_38204",
    x: 13,
    y: 8,
    width: 33,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1640_38204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38204",
    x1: 39.2478,
    y1: 10.5302,
    x2: 20.3166,
    y2: 30.0176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38204",
    x1: 0,
    y1: 12.4997,
    x2: 38,
    y2: 12.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38204",
    x1: 0,
    y1: 12.4997,
    x2: 38,
    y2: 12.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38204",
    x1: 38,
    y1: 12.5,
    x2: 17.9223,
    y2: 27.0815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTransaction);
export default __webpack_public_path__ + "static/media/menu-transaction.7cbcc924f1e36cd4d395cc4c022f301c.svg";
export { ForwardRef as ReactComponent };